export enum InternetConnectionState {
  ETHERNET,
  WIFI,
  CELLULAR,
  CELLULAR_2G,
  CELLULAR_3G,
  CELLULAR_4G,
  UNKNOWN,
  OFFLINE
}